import React, { ReactNode, useState } from 'react';
import {
  MuligePraksisstedDto,
  PraksisstedbrukerDto,
  RolleDto,
} from '../../api/generated/studiested-generated-api';
import { ConfirmationDialog } from '../../components/dialog';
import * as css from '../rolleliste.module.scss';
import RollelistePraksisstederDropDown from './rollelistePraksisstederDropDown';
import translations from '../rolleliste.i18n';
import { useFormatMessageFor } from '../../i18n/translation';
import Button from '../../components/button';
import RollelistePraksisstedbrukerDropDown from './rollelistePraksisstedbrukerDropDown';
import classNames from 'classnames';

interface RollelistePraksisstedbrukerDialogProps {
  id: string;
  defaultPraksissted: MuligePraksisstedDto | undefined;
  rollerData: RolleDto[] | undefined;
  title?: ReactNode;
  onClose?: (ok: boolean, selectedItem?: PraksisstedbrukerDto) => void;
  onSelectedPraksissted?: (selectedItem: MuligePraksisstedDto) => void;
}

const RollelistePraksisstedbrukerDialog = ({
  id,
  defaultPraksissted,
  rollerData,
  title,
  onClose,
  onSelectedPraksissted,
}: RollelistePraksisstedbrukerDialogProps) => {
  const labels = useFormatMessageFor(translations);

  const [selectedPraksisstedBruker, setSelectedPraksisstedbruker] =
    useState<PraksisstedbrukerDto>();
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <ConfirmationDialog
        key={`confirmation-dialog-${id}`}
        extraClasses={css.rolleListeModal}
        contentCss={css.rolleListeContent}
        title={labels.modalHeaderVeileder}
        subtitle={title}
        isOpen={modalVisible}
        submitLabel={labels.confirm}
        cancelLabel={labels.cancel}
        submitDisabled={!selectedPraksisstedBruker}
        onClose={(ok: boolean) => {
          setModalVisible(false);
          onClose && onClose(ok, selectedPraksisstedBruker);
        }}
      >
        <RollelistePraksisstederDropDown
          id={`praksissteder-liste-${id}`}
          defaultPraksissted={defaultPraksissted}
          onChange={(value) => {
            onSelectedPraksissted && onSelectedPraksissted(value);
          }}
        />

        {defaultPraksissted && (
          <RollelistePraksisstedbrukerDropDown
            id={`prakissted-profil-${id}`}
            praksissted={defaultPraksissted}
            rollerData={rollerData}
            onChange={(value) => {
              setSelectedPraksisstedbruker(value);
            }}
          />
        )}
      </ConfirmationDialog>
      <RollelistePraksisstedbrukerDialogButton
        id={id}
        onClick={() => setModalVisible(true)}
      />
    </>
  );
};

interface RollelistePraksisstedbrukerDialogButtonsProps {
  id: string;
  onClick: () => void;
}

const RollelistePraksisstedbrukerDialogButton = ({
  id,
  onClick,
}: RollelistePraksisstedbrukerDialogButtonsProps) => {
  const labels = useFormatMessageFor(translations);

  return (
    <div
      className={classNames(css.addModalButtons, css.roleGroupButtonContainer)}
    >
      <Button.Secondary
        key={`add-ps-veileder-${id}`}
        onClick={onClick}
        testSelector={'add-ps-veileder'}
      >
        {labels.addUserVeileder}
      </Button.Secondary>
    </div>
  );
};

export default RollelistePraksisstedbrukerDialog;
